import Page from '../page';



export default class NewsDetailManager extends Page {
	constructor() {
		super();
	}
	init() {




	}
	scroll() {
		document.addEventListener('scroll', () => {
			//console.log(this.winScrollTop);

			if (this.winScrollTop >= 340) {
				infoBox.classList.add('active');
			} else {
				infoBox.classList.remove('active');
			}


		});
	}
	resize() {
		window.addEventListener('resize', function (e) {

		})
	}
}